"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var storage_1 = require("@flowio/storage");
var find_1 = __importDefault(require("lodash/find"));
var get_1 = __importDefault(require("lodash/get"));
var isString_1 = __importDefault(require("lodash/isString"));
var remove_1 = __importDefault(require("lodash/remove"));
var content_hash_1 = __importDefault(require("./util/content-hash"));
var SessionCache = /** @class */ (function () {
    function SessionCache(options) {
        this.storageKey = get_1.default(options, 'storageKey', 'flow_default_cache');
        this.maxCacheEntries = get_1.default(options, 'maxCacheEntries', 5);
    }
    SessionCache.prototype.setCacheEntry = function (cacheKey, content) {
        var entries = storage_1.session.get(this.storageKey) || [];
        // remove entry we are setting in case it already exists.
        remove_1.default(entries, { key: cacheKey });
        entries.push({
            key: cacheKey,
            value: isString_1.default(content) ? content : JSON.stringify(content),
        });
        if (entries.length > this.maxCacheEntries) {
            entries.unshift();
        }
        storage_1.session.set(this.storageKey, entries);
        return entries;
    };
    SessionCache.prototype.getCacheEntry = function (cacheKey) {
        var cacheEntries = storage_1.session.get(this.storageKey);
        var cacheEntry = get_1.default(find_1.default(cacheEntries, { key: cacheKey }), 'value', null);
        try {
            return JSON.parse(cacheEntry);
        }
        catch (e) {
            // might not be parsable ¯\_(ツ)_/¯
            return cacheEntry;
        }
    };
    SessionCache.prototype.getCacheKey = function (cacheSeedObject) {
        var extraSeeds = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            extraSeeds[_i - 1] = arguments[_i];
        }
        var hashedSeedObject = content_hash_1.default(JSON.stringify(cacheSeedObject));
        return extraSeeds ? [hashedSeedObject].concat(extraSeeds).join('-') : hashedSeedObject;
    };
    /**
     * @description get the cache entry for a specified seed object, with optional string seeds
     */
    SessionCache.prototype.get = function (cacheSeedObject) {
        var extraSeeds = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            extraSeeds[_i - 1] = arguments[_i];
        }
        var cacheKey = this.getCacheKey.apply(this, [cacheSeedObject].concat(extraSeeds));
        return this.getCacheEntry(cacheKey);
    };
    /**
     * @description set the cache entry for a specified seed object, with optional string seeds.
     */
    SessionCache.prototype.set = function (cacheSeedObject, content) {
        var extraSeeds = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            extraSeeds[_i - 2] = arguments[_i];
        }
        var cacheKey = this.getCacheKey.apply(this, [cacheSeedObject].concat(extraSeeds));
        return this.setCacheEntry(cacheKey, content);
    };
    /**
     * @description Clear the cache
     */
    SessionCache.prototype.clear = function () {
        storage_1.session.set(this.storageKey, []);
    };
    return SessionCache;
}());
exports.default = SessionCache;



//////////////////
// WEBPACK FOOTER
// ./~/@flowio/cache/dist/src/SessionCache.js
// module id = 534
// module chunks = 0 1